import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ru6an13eof: FaireBrandEntity = {
  token: "b_ru6an13eof",
  type: "brand",
  name: "Blue B",
  avatarUrl:
    "https://cdn.faire.com/fastly/19c2c69e7631b031f54a077f2efd429ac9f2bdac99633b4acc19ef511b9d2500.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0490cdc2837d153ae6eb4810fcc6b56e4d419c82abc09dca7c7dea7e18186d7c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/19c2c69e7631b031f54a077f2efd429ac9f2bdac99633b4acc19ef511b9d2500.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0490cdc2837d153ae6eb4810fcc6b56e4d419c82abc09dca7c7dea7e18186d7c.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 813,
  isTopShop: true,
  isInsider: true,
  description:
    "Blue B is a wholesale company, located in the heart of Los Angeles, California. We specialize in young contemporary designs with specific details you'll only find with us!\n\nWe believe all clothing has a story to tell. Not only does it voices our personality but it also reflects our inner beauty. We design our clothes to compliment who you are already. Be confident, stylish and original as we walk step by step with you.\n\nWe appreciate your business and look forward to bringing you our latest designs. Our customers are our inspiration to deliver the best and the latest fashion worldwide! We take joy in our customer service and satisfaction. If you have any questions, please feel free to contact us.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:25.248Z",
    importedBy: "entity-db-cli",
  },
};
